module.exports = __webpack_public_path__ + "media/images/static/top/local/photo1-dcc109d6e925e4592e3856ce07d38c87.png";